import { IncidentsActivityPanelController } from '../controller/IncidentsActivityPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IncidentsActivityPanelWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IncidentsActivityPanelController,
    });
  }
}
